export type FieldSize = 'sm' | 'md';

/** Height + horizontal padding per size — mirrors Btn's h-8 / h-10 scale. */
const SIZE: Record<FieldSize, string> = {
  sm: 'h-8 px-2.5 text-sm-label',
  md: 'h-10 px-3 text-body',
};

/**
 * Shared visual language for text inputs and selects: warm border, real
 * focus ring (matches Btn), hover affordance, and disabled treatment.
 * Intentionally sets no width — inside a Field's flex column the control
 * stretches automatically; elsewhere the caller passes a width class.
 */
const BASE =
  'rounded-btn border border-line bg-surface text-ink placeholder:text-ink-4 ' +
  'transition-colors duration-100 hover:border-ink-3/60 ' +
  'focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 ' +
  'disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-line';

export function controlClass(size: FieldSize = 'md', extra = ''): string {
  return `${BASE} ${SIZE[size]} ${extra}`.trim();
}
